export const BaseChartOptions: Highcharts.Options = {
  title : { text: undefined },
  credits: { enabled: false },
  chart: {
    events: {
      render: (event:any) => undefined // Instantiated in ReportChartComponent
    }
  }
} as const;
